(function($) {
  var $form = $('#booking_form');
  var $uiCheckin = $form.find('.box-checkin')
  var $uiCheckout = $form.find('.box-checkout')

  function updateCheckin( dateobj ) {
    var date = moment( dateobj )
    $uiCheckin.find('.day').text( date.format('dddd') )
    $uiCheckin.find('.date').text( date.format('DD') )
    $uiCheckin.find('.month').text( date.format('MMM') )
    $uiCheckin.find('.year').text( date.format('YYYY') )
    $form.find('[name=checkin]').val( date.format('YYYY-MM-DD') )
  }

  function updateCheckout( dateobj ) {
    var date = moment( dateobj )
    $uiCheckout.find('.day').text( date.format('dddd') )
    $uiCheckout.find('.date').text( date.format('DD') )
    $uiCheckout.find('.month').text( date.format('MMM') )
    $uiCheckout.find('.year').text( date.format('YYYY') )
    $form.find('[name=checkout]').val( date.format('YYYY-MM-DD') )
  }
  
  //
  // Set i18n for Air-datepicker library
  //
  $.fn.datepicker.language = {
    en: {
      days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      daysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      daysMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
      months: ['January','February','March','April','May','June', 'July','August','September','October','November','December'],
      monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      today: 'Today',
      clear: 'Clear',
      dateFormat: 'mm/dd/yyyy',
      timeFormat: 'hh:ii aa',
      firstDay: 0
    },
    th: {
      days: ['อาทิตย์', 'จันทร์', 'อังคาร', 'พุธ', 'พฤหัสบดี', 'ศุกร์', 'เสาร์'],
      daysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      daysMin: ['อา.', 'จ.', 'อ.', 'พ.', 'พฤ.', 'ศ.', 'ส.'],
      months: ['มกราคม','กุมภาพันธ์','มีนาคม','เมษายน','พฤษภาคม','มิถุนายน', 'กรกฏาคม','สิงหาคม','กันยายน','ตุลาคม','พฤศจิกายน','ธันวาคม'],
      monthsShort: ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'],
      today: 'วันนี้',
      clear: 'ล้าง',
      dateFormat: 'dd/mm/yyyy',
      timeFormat: 'hh:ii',
      firstDay: 0
    },
    zh: {
      days: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
      daysShort: ['日', '一', '二', '三', '四', '五', '六'],
      daysMin: ['日', '一', '二', '三', '四', '五', '六'],
      months: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
      monthsShort: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
      today: '今天',
      clear: '清除',
      dateFormat: 'yyyy-mm-dd',
      timeFormat: 'hh:ii',
      firstDay: 1
    }
  }

  var datepicker = $('.box-datepicker__el').datepicker({
    language: local.language.slice(0, 2), // Need to slice because Chinese language is return too much string
    range: true,
    dateFormat: 'yyyy-mm-dd',
    minDate: new Date(),
    onSelect(f, d, inst) {
      if (d.length >= 2) {
        updateCheckin( d[0] )
        updateCheckout( d[1] )
        $('.box-reservation').removeClass('show-datepicker')
      }
    }
  })

  var datepickerInst = datepicker.data('datepicker')
  var checkinStart = local.booking.checkin_start ? local.booking.checkin_start: 0
  var reservationRange = local.booking.reservation_range ? local.booking.reservation_range : 1

  datepickerInst.selectDate([
    new Date( new Date().setDate( new Date().getDate() + checkinStart ) ),
    new Date( new Date().setDate( new Date().getDate() + checkinStart + reservationRange ) )
  ])

  var selectedDates = datepickerInst.selectedDates;
  updateCheckin( selectedDates[0] )
  updateCheckout( selectedDates[1] )

  $('.box-reservation__inner').on('click', () => {
    var $btn = $('.box-reservation')

    if ( !$btn.hasClass('show-datepicker') ) {
      $btn.addClass('show-datepicker')
      
      $(document).on('click.datepicker', event => {
        if (
          !$(event.target).closest('.box-reservation').length &&
          !$(event.target).closest('.datepickers-container').length &&
          !$(event.target).closest('.datepicker--nav-action').length &&
          !$(event.target).closest('.datepicker--nav-title').length &&
          !$(event.target).closest('.datepicker--time').length &&
          !$(event.target).is('.datepicker--cell')
        ) {
          $('.box-reservation').removeClass('show-datepicker')
          $(document).off('click.datepicker')
        }
      })
    } else {
      $btn.removeClass('show-datepicker')
      $(document).off('click.datepicker')
    }
  })

  $('[ui-spinner]').each((i, el) => {
    var
    num = $(el).find('.number'),
    inc = $(el).find('.increase'),
    dec = $(el).find('.decrease'),
    min = num.data('min') || 0,
    max = num.data('max') || 99,
    upd = num.data('update')

    function controlState(num) {
       inc.prop('disabled', () => num == max)
       dec.prop('disabled', () => num == min)
    }

    function updateField(num) {
      $(upd).val(num)
    }

    controlState( Number(num.text()) )
    updateField( Number(num.text()) )

    var current = Number( num.text() );

    inc.on('click', () => {
      if (current++ < max) {
        num.text( current )
        controlState( current )
        updateField( current )
        current = current
      }
    })

    dec.on('click', () => {
      if (current-- > min) {
        num.text( current )
        controlState( current )
        updateField( current )
        current = current
      }
    })
  })
})(jQuery);